<template>
    <DCard
        padding
    >
        <Form
            :to-edit="taxExemption"
            :errors="errors"
            :countries="countries"
            :tenant-languages="tenantLanguages"
            :default-tenant-language="defaultTenantLanguage"
            :effectiveness="effectiveness"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @TaxExemptionFormSubmit="update"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TaxExemption/Form'

export default {
    name: 'TaxExemptionEdit',
    components: { Form },
    props: {
        taxExemption: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        defaultTenantLanguage: {
            type: Object,
            default: () => { return {} }
        },
        tenantLanguages: {
            type: Array,
            default: () => []
        },
        effectiveness: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        update (form) {
            form.put(this.$route('settings.tax-exemption.update', {
                tax_exemption: form.id
            }))
        }
    }
}
</script>

<style scoped>

</style>
